import { lazy } from 'react';

const RELOAD_FLAG = 'lazy_chunk_reloaded';

/**
 * React.lazy for route pages. After a deploy, a device still running the old version can ask
 * for page files that no longer exist; reload once to pick up the new version instead of
 * showing a blank screen. If it fails again after the reload, the error is shown as usual.
 */
export default function lazyWithRetry(importPage) {
  return lazy(() =>
    importPage()
      .then((module) => {
        try {
          sessionStorage.removeItem(RELOAD_FLAG);
        } catch {
          // sessionStorage unavailable; nothing to clear
        }
        return module;
      })
      .catch((error) => {
        let alreadyReloaded = false;
        try {
          alreadyReloaded = sessionStorage.getItem(RELOAD_FLAG) === '1';
          if (!alreadyReloaded) sessionStorage.setItem(RELOAD_FLAG, '1');
        } catch {
          alreadyReloaded = true;
        }
        if (!alreadyReloaded) {
          window.location.reload();
          return new Promise(() => {}); // keep showing the loader while the page reloads
        }
        throw error;
      })
  );
}
